import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: "9e4256f3-c154-4215-a43c-3c2fc985d115",
    authority: "https://login.microsoftonline.com/81a2d85f-84ca-4436-bd45-2e5f9c8c43ec",
    redirectUri: "https://gpt.azure-youplus-services.com/signin-oidc", // S.I. this was http://localhost:3040/signin-oidc and is frontend URL (not webapi)
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  }
};

const msalInstance = new PublicClientApplication(msalConfig);

export default msalInstance;